import { Collection1k04j3hzsbod0 as Collection } from '../collections/Collections.mjs';
import { initMetadataForInterface1egvbzx539z91 as initMetadataForInterface } from '../js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var MatchNamedGroupCollectionClass;
function MatchNamedGroupCollection() {
  if (MatchNamedGroupCollectionClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'MatchNamedGroupCollection', VOID, VOID, [Collection()]);
    MatchNamedGroupCollectionClass = $;
  }
  return MatchNamedGroupCollectionClass;
}
//region block: exports
export {
  MatchNamedGroupCollection as MatchNamedGroupCollection2nkf1ok7z2wgd,
};
//endregion

//# sourceMappingURL=MatchResult.mjs.map
